import { LOCATION_TYPE } from "@/constants/constants";
import { LOAI_DU_LIEU_DANH_MUC } from "@/constants/phanAnhKienNghi";
import {
  callApiGetLocations,
  callApiGetDataDanhMuc,
  callApiTaoPakn,
  callApiGetDetailPakn,
  callApiGetListPAKN,
  callGetLinhVucPAKN
} from "@/api/pakn";

const getLocation = (context, payload) => {
  const locationType = payload.locationType;
  delete payload.locationType;
  callApiGetLocations(payload)
    .then((response) => {
      if (response) {
        switch (locationType) {
          case LOCATION_TYPE.PROVINCE: {
            context.commit("SET_PROVINCES", response.data);
            break;
          }
          case LOCATION_TYPE.DISTRICT: {
            context.commit("SET_DISTRICTS", response.data);
            break;
          }
          case LOCATION_TYPE.COMMUNES: {
            context.commit("SET_COMMUNES", response.data);
            break;
          }
        }
      }
    })
    .catch((error) => {
      console.error(error);
    });
};

const getDataDanhMuc = (context, payload) => {
  callApiGetDataDanhMuc(payload)
    .then((response) => {
      if (response) {
        switch (payload.type) {
          case LOAI_DU_LIEU_DANH_MUC.LuatPAKN: {
            context.commit("SET_LUAT_PAKN", response.data);
            break;
          }
          case LOAI_DU_LIEU_DANH_MUC.NguonPAKN: {
            context.commit("SET_NGUON_PAKN", response.data);
            break;
          }
          case LOAI_DU_LIEU_DANH_MUC.NoiDungPAKN: {
            context.commit("SET_NOI_DUNG_PAKN", response.data);
            break;
          }
        }
      }
    })
    .catch((error) => {
      console.error(error);
    });
};

const taoPakn = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoPakn(payload)
      .then((res) => {
        if (res) {
          resolve(res);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDetailPAKN = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDetailPakn(payload)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getListPAKN = async (context, payload) => {
  const response = await callApiGetListPAKN(payload.data);
  if (response && response.data.IsSuccess) {
    payload.onSuccess && payload.onSuccess(response.data.Data);
  }
};
const getLinhVucPAKN = (context, payload) => {
  return new Promise((resolve, reject) => {
    callGetLinhVucPAKN(payload)
        .then((response) => {
          context.commit("SET_LINH_VUC_PAKN", response.data.Data);
          if (response) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
  });
};

export default {
  getLocation,
  getDataDanhMuc,
  taoPakn,
  getDetailPAKN,
  getListPAKN,
  getLinhVucPAKN
};
